import { DOMAIN } from "./domain-constant";

export const GEMS = [
  {
    id: 1,
    title: "Gems",
    icon: "icon-hour-calculator",
  },
  {
    id: 2,
    title: "Types",
    icon: "icon-hour-calculator",
  },

  {
    id: 5,
    title: "Hour Calculator",
    icon: "icon-hour-calculator",
  },
  {
    id: 6,
    title: "Loan Amortization",
    icon: "icon-loan-amortization",
  },
  {
    id: 10,
    title: "Payroll: Reports",
    icon: "icon-company-log",
  },
  {
    id: 11,
    title: "Payroll: Useful Links",
    icon: "icon-useful-links",
  },
  {
    id: 12,
    title: "Payroll: Filing Cabinet",
    icon: "icon-filing-cabinet",
  },
  {
    id: 14,
    title: "Upcoming Important Dates",
    icon: "icon-upcoming-dates",
  },
  {
    id: 17,
    slug: "employees",
    title: "[Employees]",
    icon: "icon-employees",

    displaySearch: true,
    displayAdvanceBtn: true,
  },

  {
    id: 18,
    title: "[Vendors]",
    icon: "icon-vendors",
  },
  {
    id: 20,
    title: "Files: Yearly Documents",
    icon: "icon-yearly-documents",
  },
  {
    id: 21,
    title: "Files: Personnel Documents",
    icon: "icon-personnel-documents",
  },
  {
    id: 22,
    title: "Files: Permanent Documents",
    icon: "icon-permanent-documents",
  },

  // originally 23 is Analog Clock GEMS ID BUT I USED IN FOR CLIENT FOR SOME TIME
  // {
  //   id: 23,
  //   title: "Analog Clock ",
  //   icon: "icon-analog-clock",

  //   displaySettingsBtn: true,
  // },

  {
    id: 23,
    title: "Clients",
    icon: "icon-analog-clock",
    displaySettingsBtn: true,
  },
  {
    id: 24,
    title: "Payables by Aging Period",
    icon: "icon-payables-by-aging-period",
  },
  {
    id: 25,
    title: "My Quick Notes",
    icon: "icon-quick-notes",
  },
  {
    id: 27,
    title: "Client Resources",
    icon: "icon-client-resources",
  },
  {
    id: 28,
    title: "Income vs Expense",
    icon: "icon-Income vs Expense",
  },
  {
    id: 29,
    title: "Account Balance",
    icon: "icon-account-balance",
  },
  {
    id: 30,
    title: "Payables: Filing Cabinet",
    icon: "icon-filing-cabinet",
  },
  {
    id: 31,
    title: "Reports: Filing Cabinet",
    icon: "icon-filing-cabinet",
  },
  {
    id: 32,
    title: "Reports: PDFs for Last 3 Months",
    icon: "icon-pdfs-for-Last-3-Months",
  },
  {
    id: 33,
    title: "Reports: My Yearly Goal Tracker",
    icon: "icon-company-log",
  },
  {
    id: 34,
    title: "[Customers]",
    icon: "icon-employees",
  },
  {
    id: 35,
    title: "[Invoices]",
    icon: "icon-company-log",
  },
  {
    id: 36,
    title: "Inventory",
    icon: "icon-company-log",
  },
  {
    id: 38,
    title: "Fixed Assets",
    icon: "icon-company-log",
  },
  {
    id: 40,
    title: "[Estimates]",
    icon: "icon-estimates",
  },
  {
    id: 42,
    title: "Receivables by Aging Period",
    icon: "icon-company-log",
  },
  {
    id: 44,
    title: "Receivables: Reports",
    icon: "icon-company-log",
  },
  {
    id: 45,
    title: "[Jobs]",
    icon: "icon-jobs",
  },
  {
    id: DOMAIN.CLASSIFICATION,
    title: "[Classification]",
    icon: "icon-classes",
  },
  {
    id: 56,
    title: "[CreditMemos]",
    icon: "icon-company-log",
  },
  {
    id: 58,
    title: "Chart of Accounts",
    icon: "icon-company-log",
  },
  {
    id: 73,
    title: "Reports: Top [Customers]",
    icon: "icon-company-log",
  },
  {
    id: 76,
    title: "Clients",
    icon: "icon-client-resources",
  },
  {
    id: 75,
    title: "Weather Forecast",
    icon: "icon-weather",
  },
  {
    id: 89,
    title: "Users",
    icon: "icon-Users",
    displaySearch: true,
    displayAdvanceBtn: true,
  },
  {
    id: 104,
    title: "Ploion Group History",
    icon: "icon-company-log",
  },
  {
    id: 116,
    title: "My Websites",
    icon: "icon-company-log",
  },
  {
    id: 117,
    title: "[SalesReceipts]",
    icon: "icon-sales-receipts",
  },
  {
    id: 119,
    title: "E-Mail Blaster",
    icon: "icon-company-log",
  },
  {
    id: 128,
    title: "Files: Upload Documents",
    icon: "icon-upload-documents",
  },
  {
    id: 129,
    title: "Payroll: Processing",
    icon: "icon-company-log",
  },
  {
    id: 136,
    title: "Receivables: Items",
    icon: "icon-receivables-items",
  },
  {
    id: 137,
    title: "Receivables: Processing",
    icon: "icon-company-log",
  },
  {
    id: 140,
    title: "Payables: Processing",
    icon: "icon-company-log",
  },
  {
    id: 143,
    title: "Time Worked",
    icon: "icon-company-log",
  },
  {
    id: 144,
    title: "Tasks",
    icon: "icon-company-log",
  },
  {
    id: 145,
    title: "[Prospects]",
    icon: "icon-company-log",
  },
  {
    id: 146,
    title: "[Opportunities]",
    icon: "icon-company-log",
  },
  {
    id: 148,
    title: "[OtherContacts]",
    icon: "icon-other-contacts",
  },
  {
    id: 149,
    title: "Private Contacts",
    icon: "icon-private-contacts",
  },
  {
    id: 150,
    title: "Milestones",
    icon: "icon-company-log",
  },
  {
    id: 151,
    title: "Mileage & Expenses",
    icon: "icon-company-log",
  },
  {
    id: 153,
    title: "Time Off",
    icon: "icon-company-log",
  },
  {
    id: 156,
    title: "Notepads",
    icon: "icon-notepads",
    displaySearch: true,
    displayAdvanceBtn: true,
  },
  {
    id: 157,
    title: "Invoices",
    icon: "icon-notepads",
    displaySearch: true,
    displayAdvanceBtn: true,
  },
  {
    id: 166,
    title: "Storage Report",
    icon: "icon-files",

    displaySearch: true,
    displayAdvanceBtn: true,
  },
  {
    id: 168,
    title: "Configuration",
    icon: "icon-company-log",
  },
  {
    id: 169,
    title: "Files",
    icon: "icon-files",

    displaySearch: true,
    displayAdvanceBtn: true,
  },
  {
    id: DOMAIN.WORK_ORDER,
    title: "[WorkOrders]",
    icon: "icon-work-orders",
  },
  {
    id: 174,
    title: "Journal Entries",
    icon: "icon-company-log",
  },
  {
    id: 177,
    title: "Banking",
    icon: "icon-company-log",
  },
  {
    id: 179,
    title: "Credit Cards",
    icon: "icon-company-log",
  },
  {
    id: 180,
    title: "Funds Received",
    icon: "icon-company-log",
  },
  {
    id: 186,
    title: "Reporting",
    icon: "icon-company-log",
  },
  {
    id: 187,
    title: "Profit and Loss",
    icon: "icon-company-log",
  },
  {
    id: 190,
    title: "Important Dates",
    icon: "icon-company-log",
  },
  {
    id: 191,
    title: "Debt Calculator",
    icon: "icon-company-log",
  },
  {
    id: 192,
    title: "Date Calculator",
    icon: "icon-company-log",
  },
  {
    id: 194,
    title: "Print Que",
    icon: "icon-company-log",
  },

  // its a title Announcement domain but currently we use return items for testing after that we remove it

  // {
  //   id: 200,
  //   title: "Announcement",
  //   icon: "icon-company-log",
  // },

  {
    id: 200,
    title: "Return Items",
    icon: "icon-company-log",
  },
  {
    id: 201,
    title: "Email Manager",
    icon: "icon-company-log",
  },
  {
    id: 203,
    title: "Purchase Order",
    icon: "icon-company-log",
  },
  {
    id: 205,
    title: "Receivings",
    icon: "icon-company-log",
  },
  {
    id: 206,
    title: "Sales Order",
    icon: "icon-company-log",
  },
  {
    id: 207,
    title: "Company Logs",
    icon: "icon-company-log",
  },
  {
    id: 208,
    title: "Attendance",
    icon: "icon-company-log",
  },
  {
    id: 209,
    title: "Pending Clients",
    icon: "icon-client-resources",
  },
  {
    id: 210,
    title: "Clients",
    icon: "icon-client-resources",
  },
  {
    id: 303,
    title: "Testing Module",
    icon: "icon-client-resources",
  },
  {
    id: 304,
    title: "Automated Tasks",
    icon: "icon-employees",
  },
];
